<template>
  <div class="daily-food-menu">
    <div class="list">
      <div class="title">
        <h1>{{appIsDemo ? '生成数据' : '模拟数据'}}</h1>
        <!-- <div class="fun">
          <a-button size="large" @click="downloadAutoTemplate()">
            导出循环模板
          </a-button>
          <a-upload
          name="file"
          :withCredentials="true"
          :showUploadList="false"
          accept=".xlsx"
          :action="autoUploadUrl + '?meal=breakfast'"
          :beforeUpload="onBeforeUpload"
          @change="handleChange"
          :data="{school_id:currentSchool._id}"
          >
          <a-button
            size="large"
            :loading="isUploading"
          >导入循环菜单-早餐</a-button>
          </a-upload>
          <a-upload
          name="file"
          :withCredentials="true"
          :showUploadList="false"
          accept=".xlsx"
          :action="autoUploadUrl + '?meal=lunch'"
          :beforeUpload="onBeforeUpload"
          @change="handleChange"
          :data="{school_id:currentSchool._id}"
          >
          <a-button
            size="large"
            :loading="isUploading"
          >导入循环菜单-午餐</a-button>
          </a-upload>
          <a-upload
          name="file"
          :withCredentials="true"
          :showUploadList="false"
          accept=".xlsx"
          :action="autoUploadUrl + '?meal=dinner'"
          :beforeUpload="onBeforeUpload"
          @change="handleChange"
          :data="{school_id:currentSchool._id}"
          >
          <a-button
            size="large"
            :loading="isUploading"
          >导入循环菜单-晚餐</a-button>
          </a-upload>
        </div> -->
        <div class="fun">
          <div class="button">
            <a-button size="large" @click="downloadTemplate()">
              导出模板
            </a-button>
            <a-upload
            name="file"
            :withCredentials="true"
            :showUploadList="false"
            accept=".xlsx"
            :action="uploadUrl"
            :beforeUpload="onBeforeUpload"
            @change="handleChange"
            :data="{school_id:currentSchool._id}"
            >
            <a-button
                size="large"
                :loading="isUploading"
            >导入</a-button>
            </a-upload>
            <a-button type="primary" size="large" @click="add">
              新增菜单
            </a-button>
            <a-button type="primary" size="large" @click="auto">
              循环菜单
            </a-button>
          </div>
        </div>
      </div>
      <div class="table">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="pagination"
          @change="handleTableChange"
          bordered
          class="custom-table"
          :scroll="{ x: 900 }"
          rowKey="id"
        >
          <template slot="operation" slot-scope="text, record, index">
            <div class="operation">
              <a @click="edit(record)" :disabled="record.status === '已生成'"
                >编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :title="'确定删除 [' + record.date + '] 的菜单吗?'"
                ok-text="确定"
                cancel-text="取消"
                @confirm="onDel(record, index)"
              >
                <a :disabled="record.status === '已生成'">删除</a>
              </a-popconfirm>
              <a-divider type="vertical" v-if="appIsDemo" />
               <a @click="creatNow(record)" v-if="appIsDemo" :disabled="isDisabled(record)"
                >生成</a>
            </div>
          </template>
        </a-table>
      </div>
      <daily-food-menu-edit @saved="loadList"></daily-food-menu-edit>
      <daily-food-menu-auto></daily-food-menu-auto>
    </div>
  </div>
</template>

<script>
import DailyFoodMenuEdit from '@/components/dailyFoodMenu/Edit'
import DailyFoodMenuAuto from '@/components/dailyFoodMenu/Auto'
import apis from '@/business/apis'
import { mapState } from 'vuex'

const columns = [
  {
    title: '日期',
    dataIndex: 'date'
  },
  {
    title: '菜单',
    dataIndex: 'food'
  },
  {
    title: '餐次',
    dataIndex: 'mealTypeName'
  },
  {
    title: '状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'operation' },
    width: 160
  }
]

export default {
  inject: ['eventBus'],
  data: () => ({
    isUploading: false,
    uploadUrl: apis.dailyFoodMenu.importExcel,
    autoUploadUrl: apis.dailyFoodMenu.importAutoExcel,
    list: [],
    isLoading: false,
    pagination: {},
    columns,
    mealTypeList: [
      { name: '早餐', value: 'breakfast' },
      { name: '午餐', value: 'lunch' },
      { name: '晚餐', value: 'dinner' },
      { name: '宵夜', value: 'nightSnack' }
    ]
  }),
  computed: {
    ...mapState('school', ['currentSchool'])
  },
  methods: {
    add () {
      this.eventBus.$emit('show-daily-food-menu-edit')
    },
    auto () {
      this.eventBus.$emit('show-daily-food-menu-auto')
    },
    edit (record) {
      this.eventBus.$emit('show-daily-food-menu-edit', record.id)
    },
    onDel (record, index) {
      this.del(record, index)
    },
    async del (record, index) {
      const response = await this.$http.post(
        apis.dailyFoodMenu.delete + record.id
      )
      const result = response.body
      console.log(result)
      this.list.splice(index, 1)
    },
    async loadList () {
      this.isLoading = true
      const params = {
        schoolId: this.currentSchool.id,
        current: this.pagination.current
      }
      const response = await this.$http.get(apis.dailyFoodMenu.list, {
        params
      })
      const result = response.body
      this.list = result.list
      this.list.forEach(item => {
        item.mealTypeName = this.mealTypeList.find(
          v => v.value === item.meal_type
        ).name
        for (let i = 0; i < item.foods.length; i++) {
          const temp = item.foods[i]
          if (typeof temp === 'string') {
            item.foods[i] = { name: temp } // 字符串转成对象
          }
        }
        item.food = item.foods.map((k) => {
          return k.name
        }).join(',')
        if (!item.food) item.food = '随机'
      })
      this.pagination = result.pagination

      this.isLoading = false
    },
    handleTableChange ({ current }) {
      this.pagination.current = current
      this.loadList()
    },
    handleChange ({ file }) {
      switch (file.status) {
        case 'uploading':
          this.isUploading = true
          break
        case 'done':
          this.isUploading = false
          this.handleUploadFinish(file.response)
          break
        case 'error':
          this.isUploading = false
          this.$message.error('上传失败')
          break
      }
    },
    async handleUploadFinish (result) {
      this.$message.destroy()
      if (result.err) {
        this.$message.error(result.errMsg)
        return
      }
      this.downloadFile(apis.file.runtime + result.name)
      this.loadList()
      this.$message.success(`导入完成，成功${result.nSuccessed}条，失败${result.nFailed}条，详情请查看导入菜单结果`, 5)
    },
    async onBeforeUpload (file) {
      const maxSize = 10 * 1000 * 1000
      if (file.size > maxSize) {
        this.$message.error('文件大小不可以超过10M')
        return Promise.reject(Error())
      }
      this.$message.info('正在导入...')
    },
    async downloadTemplate () {
      this.downloadFile(apis.file.static + '导入菜单模板.xlsx')
    },
    async downloadAutoTemplate () {
      this.downloadFile(apis.file.static + '导入循环菜单模板.xlsx')
    },
    async downloadFile (url) {
      console.log('download', url)
      let e = window.document.getElementById('_staticFileLink')
      if (!e) {
        e = window.document.createElement('a')
        e.setAttribute('id', '_staticFileLink')
      }
      e.setAttribute('href', url)
      e.click()
    },
    isDisabled (data) {
      if (!data) return true
      if (data.status === '已生成') {
        return true
      }
      return false
    },
    async creatNow (data) {
      this.$message.destroy()
      this.$message.loading('正在生成...')
      try {
        await this.$http.post(apis.dailyFoodMenu.runNow, { id: data._id })
      } catch (error) {
      }
      this.$message.destroy()
      this.$message.info('操作完成')
      this.loadList()
    }
  },
  created () {
    this.loadList()
  },
  components: {
    DailyFoodMenuEdit,
    DailyFoodMenuAuto
  }
}
</script>

<style lang="less">
.daily-food-menu {
  .list {
    border: 1px solid #e7e7eb;
    background: #fff;
    border-radius: 6px;
    padding: 0 16px;
    > .title {
      padding-top: 16px;
      display: flex;
      align-items: center;
      h1 {
        flex: 1;
        font-size: 20px;
      }
      .fun {
        display: flex;
        align-items: center;
        .button {
          display: flex;
          align-items: center;
          .ant-btn {
            width: 110px;
            margin-left: 16px;
          }
        }
      }
    }
    .table {
      margin: 16px 0;
    }
  }
}
.descinfo-model {
  .hd {
    h1 {
      font-size: 28px;
      margin: 0;
    }
    p {
      margin: 0;
      font-size: 14px;
      color: #999;
    }
  }
  .info {
    margin: 16px -12px 0 0;
    .tiva {
      padding: 14px 12px 12px;
      margin: 0 12px 12px 0;
      line-height: 1.2;
      background: #f2f2f2;
      border-radius: 6px;
      height: 70px;
      .title {
        color: #999;
      }
      .value {
        margin-top: 8px;
        font-size: 16px;
      }
    }
  }
  .timeline {
    margin: 24px 0 -20px;
    .item {
      .name {
        font-size: 16px;
      }
      .other {
        color: #999;
        margin-top: 4px;
        > div {
          margin-top: 2px;
        }
      }
    }
  }
  .button {
    border-top: 1px solid #e8e8e8;
    text-align: center;
    padding-top: 24px;
    margin-top: 20px;
    .ant-btn {
      width: 120px;
    }
  }
}
.addsimulationfood-model,
.editsimulationfood-model {
  .delete-button {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: -36px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
}
</style>
